// Paleta de colores centralizada
export const colors = {
  // Colores primarios (azules)
  primary: {
    main: '#2563eb',
    light: '#60a5fa',
    dark: '#1d4ed8',
    contrastText: '#ffffff',
  },

  // Colores secundarios (verdes)
  secondary: {
    main: '#10b981',
    light: '#34d399',
    dark: '#059669',
    contrastText: '#ffffff',
  },

  // Colores de estado
  // ⚠️ IMPORTANTE: Estos colores se usan globalmente en las notificaciones
  // Para cambiar el color verde de las notificaciones de éxito, modifica 'success.main'
  // Ejemplo: cambiar a azul: main: '#2563eb'
  // Ejemplo: cambiar a morado: main: '#7c3aed'
  // Ejemplo: cambiar a turquesa: main: '#06b6d4'
  // 🎨 Color verde esmeralda con toque cyan (similar a los botones "Añadir" y "Buscar")
  success: {
    main: '#0CBB9A', // 🎨 Verde esmeralda-cyan (tealMedium) - igual a los botones del catálogo
    light: '#10B981', // Verde esmeralda (greenButton) - para estados activos
    dark: '#059669', // Verde oscuro - para bordes/sombras
    contrastText: '#ffffff', // Color del texto sobre el fondo
  },

  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
    contrastText: '#ffffff',
  },

  error: {
    main: '#ef4444',
    light: '#f87171',
    dark: '#dc2626',
    contrastText: '#ffffff',
  },

  info: {
    main: '#06b6d4',
    light: '#22d3ee',
    dark: '#0891b2',
    contrastText: '#ffffff',
  },

  // Colores neutros
  grey: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Colores de fondo
  background: {
    default: '#ffffff',
    paper: '#f9fafb',
  },

  // Colores de texto
  text: {
    primary: '#111827',
    secondary: '#6b7280',
    disabled: '#9ca3af',
  },
};
